/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-notes.reducer';

export const TreatmentNotesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentNotesEntity = useAppSelector(state => state.treatmentNotes.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentNotesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentNotes.detail.title">TreatmentNotes</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentNotes.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentNotesEntity.id}</dd>
          <dt>
            <span id="progressSummary">
              <Translate contentKey="tinyMedicRestApp.treatmentNotes.progressSummary">Progress Summary</Translate>
            </span>
          </dt>
          <dd>{treatmentNotesEntity.progressSummary}</dd>
          <dt>
            <span id="proposedPlan">
              <Translate contentKey="tinyMedicRestApp.treatmentNotes.proposedPlan">Proposed Plan</Translate>
            </span>
          </dt>
          <dd>{treatmentNotesEntity.proposedPlan}</dd>
          <dt>
            <span id="otherNotes">
              <Translate contentKey="tinyMedicRestApp.treatmentNotes.otherNotes">Other Notes</Translate>
            </span>
          </dt>
          <dd>{treatmentNotesEntity.otherNotes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentNotes.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentNotesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.treatmentNotes.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{treatmentNotesEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentNotes.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentNotesEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.treatmentNotes.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{treatmentNotesEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentNotes.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentNotesEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentNotes.treatmentPlan">Treatment Plan</Translate>
          </dt>
          <dd>{treatmentNotesEntity.treatmentPlan ? treatmentNotesEntity.treatmentPlan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentNotes.doctor">Doctor</Translate>
          </dt>
          <dd>{treatmentNotesEntity.doctor ? treatmentNotesEntity.doctor.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-notes" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-notes/${treatmentNotesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentNotesDetail;
